export const personalStatementTemplate = {
  id: 'personalStatement',
  title: 'Personal Statement',
  description: 'For longer essay prompts asking you to share your story, background, or what shaped who you are today',
  wordTarget: 500,
  sections: [
    {
      id: 'opening_scene',
      label: 'Opening Scene',
      type: 'opening',
      prompt: 'Drop us into a specific moment that captures something essential about you. Not your whole life story — one scene.',
      coachVoice: "The best openings are cinematic. Put us in a specific place, at a specific time, doing a specific thing. 'I've always been passionate about science' is a statement. 'I was elbow-deep in pond water at 6 AM, counting tadpoles before anyone else was awake' is a scene.",
      sample: "The ER waiting room smelled like floor cleaner and anxiety. I was fifteen, translating discharge instructions for a stranger's grandmother because the hospital's interpreter line had a 45-minute wait. My Spanish wasn't perfect, but it was faster than silence.",
      minWords: 80,
      unlockWords: 40
    },
    {
      id: 'the_real_stakes',
      label: 'The Real Stakes',
      type: 'stakes',
      prompt: 'Why did this moment (or pattern of moments) matter to you? What was really at stake — not just practically, but personally?',
      coachVoice: "Go deeper than the surface event. If you helped someone, what did it cost you or teach you? If you failed at something, what assumption did it break? The stakes should feel personal, not performative.",
      sample: "That night I realized the gap between 'access to healthcare' and 'actually understanding your healthcare' is enormous — and it's a gap I'd been living in my whole life without naming it. Every time my family navigated a system that wasn't built for us, we were improvising solutions that shouldn't have been necessary.",
      minWords: 100,
      unlockWords: 50
    },
    {
      id: 'your_approach',
      label: 'Your Approach',
      type: 'approach',
      prompt: 'What did you do about it? How did you respond, adapt, create, or push forward?',
      coachVoice: "Show agency without exaggeration. You don't need to have solved a global problem. Small, genuine actions — starting a project, changing your study focus, having a hard conversation — matter more than inflated achievements.",
      sample: "I started volunteering at the free clinic not to pad my resume but because I needed to understand the system from the inside. I created bilingual health guides — not the sterile pamphlets the clinic already had, but visual guides that my grandmother would actually use. When the clinic director asked me to train other volunteers on cultural competency, I realized I'd accidentally built something useful.",
      minWords: 100,
      unlockWords: 50
    },
    {
      id: 'proof_of_growth',
      label: 'Proof of Growth',
      type: 'growth',
      prompt: 'How has this experience changed how you think, what you notice, or what you want to do next? Show us the transformation with evidence.',
      coachVoice: "Don't just say 'I grew as a person.' Show how your thinking or behavior changed. What do you notice now that you didn't before? What decisions have you made differently because of this experience?",
      sample: "I now instinctively notice when information is designed for insiders — in hospitals, at school board meetings, in financial aid offices. I'm applying to this program because I want the scientific training to back up what I already know from experience: that the biggest breakthroughs in health equity won't come from better treatments alone, but from better communication across every barrier that keeps people from the care they need.",
      minWords: 80,
      unlockWords: 40
    }
  ]
};
